import request from '../request'

export default {
  deleteImagenEmergencia(data) {
    return request.delete(`emergencia_imagen/${data.ID_EMERGENCIA}/${data.ID_EMERGENCIA_IMAGEN}`)
  },
  getImagenesEmergencia(data) {
    return request.get(`emergencia_imagen/${data}`)
  },
  setImagenesEmergencia(data) {
    return request.post(`emergencia_imagen/${data.ID_EMERGENCIA}`, data.imagenes)
  }
}
